import { ShortLinkServiceProps } from './interface';
import ShortLinkService from './ShortLinkService';

// Фабрика сервиса коротких ссылок
export const shortLinkService: { (token?: string): ShortLinkServiceProps } = (token) =>
  new ShortLinkService(token);
